/* eslint-disable import/prefer-default-export */
export const darkRedColor = '#840929';
export const yellowColor = '#f3da75';
export const darkBlueColor = '#29465d';
export const lightGrayColor = '#ececec';
export const lightGreenColor = '#31cd35';
export const darkGreenColor = '#025804';
export const darkGrayColor = '#777f85';
export const grayText = '#929191';
